import React, { useState, useEffect } from 'react';
import { Form, Field, FieldWrapper, FormElement } from '@progress/kendo-react-form';
import {FormTitle, CusFormLabel, CusFormInput} from '../validation/Form-Components';
import SubHeader from '../components/SubHeader';
import appDetailsData from '../data/applicantdetailsdata.json';
import FormContainer from '../components/FormContainer';
import { emailValidator, mobileNoValidator } from '../validation/Validators';
import config from '../appconfig/config.json';
import { useHistory } from "react-router-dom";
import CusToast from '../components/CusToast';
import Loading from '../components/Loading';
import service from '../services/ApiService';
import uploadConfig from '../data/uploaddetailsdata.json';
import storage from '../factory/StorageFactory';
import helper from '../factory/Helper.js';
 
const NonAuthPersonDetails = (props) => {
    let timer;
    const detailsType = '10';
    const seq0 = '0';
    const history = useHistory();
    const [isLoading, setIsLoading] = useState(true);  //to show api call
    const [isError,setIsError] = useState(false);
    const [errMsg, setErrMsg] = useState('');

    const [response, setResponse]  = useState({
        ApplicantsDtlsMyInfo:{}
    });
    const [nonAuthPerDtls, setNonAuthPerDtls] = useState({
        n:"",
        mno:"",
        em:"",
    });

    useEffect(() => {
        console.log('@NonAuthPersonDetails')
        if(helper.isTokenExpired()) {
            history.push(config.route.SessionExpired);
            return;
        }
        
        getData();
        return () => clearTimeout(timer);
    }, []);

    //Form Submit
    const handleSubmit = (eve) => {
        if(helper.isTokenExpired()) {
            history.push(config.route.SessionExpired);
            return;
        }
        // alert(JSON.stringify(eve.values))
        if(eve.isValid){
            let data = JSON.parse(JSON.stringify(eve.values));
            saveNonAuthPersonDtls(formatJsonParams(data));
        }
    }

    const getData = () => {
        service.get().then( res => {
            setIsLoading(false);
            if(res.data.isSucess) {
                setResponse(res.data.model.fields.request);
                bindFormData(res.data.model.fields.request);
            }
            else{
                setIsLoading(false);
            }
            
        })
        .catch(err=>{
            setIsLoading(false);
            showErrMsg('')
        })
    }


    const bindFormData = (resData) => {

        let appDtlsArray = [];

        if(!Array.isArray(resData.ApplicantDtls)){
            appDtlsArray.push(resData.ApplicantDtls);
        }
        else {
            appDtlsArray = resData.ApplicantDtls;
        }

        for(let i in appDtlsArray) {
            if(appDtlsArray[i].ApplicantSeq === '0') {
                setNonAuthPerDtls({
                    n:appDtlsArray[i].Name,
                    mno:appDtlsArray[i].MobileNo,
                    em:appDtlsArray[i].EmailAdd,
                })
            }
        }
 
    }

    const saveNonAuthPersonDtls = (params) => {
        service.post(detailsType,params).then(res=>{
            let resData = res.data
            if(resData.isSucess) {
                goNext();
            }  
            else{
                showErrMsg(resData.errorMessage);
            }         
        })
        .catch(err => {
            showErrMsg('Error: Save failed.');
        });
    }

    let formatJsonParams = function(data) {
        let appDtlsArray = [];
        appDtlsArray.push({
            IDNum:response.ApplicantsDtlsMyInfo.IDNum,
            ApplicantSeq:'0',
            Name:response.ApplicantsDtlsMyInfo.Name,
            MobileNo:data.mno,
            MobileNoCode:"65",
            EmailAdd:data.em
        })

        if(!Array.isArray(response.ApplicantDtls)){
            appDtlsArray.push(response.ApplicantDtls);
        }
        else {
            for(let i in response.ApplicantDtls){
                if(response.ApplicantDtls[i].ApplicantSeq !== seq0){
                    appDtlsArray.push(response.ApplicantDtls[i]);
                }
            }
        }

        let params = {
            CurrentUser:currentUser(),
            ApplicantDtls:appDtlsArray
        }

        return params;
    }
    
    const currentUser = () => {
        let params = {};
        params = {
            IDNum: response.ApplicantsDtlsMyInfo.IDNum,
            Seq:'0',
            Order:'0'
        }
        return params;
    }
 
    const goNext = () => {
        if(history.location.state !== undefined) {
            if(history.location.state.from === config.route.Preview) {
                history.goBack();
            }
            else {
                history.push(config.route.DeclarationDetails, { from: config.route.NonAuthPersonDetails });
            }
        }
        else {
            history.push(config.route.DeclarationDetails, { from: config.route.NonAuthPersonDetails });
        }
    }

    const showErrMsg = (msg) => {
        setIsError(true);
        setErrMsg(msg);
        setErrMsgTimeout();
    }

    const setErrMsgTimeout= () => {
        timer = setTimeout(() => {
            setIsError(false);
        }, config.error.msgTimeout);
    }

    const backBtnClick = (e) => {
        e.preventDefault(); 
        const uploadDtlsType = storage.getCompType();
       
        if(uploadDtlsType === uploadConfig.SCOType.SCO1) {
            history.push(config.route.NSUploadDetails);
        }
        else if(uploadDtlsType === uploadConfig.SCOType.SCO2) {
            history.push(config.route.LLPUploadDetails);
        }
        else if(uploadDtlsType === uploadConfig.SCOType.SCO3) {
            history.push(config.route.ACSUploadDetails);
        }
        else { 
            history.push(config.route.NSUploadDetails);
        }
    }

    if(isLoading) {
        return(
            <Loading />
        )
    }

    return(
        <div className="container-fluid">
          <SubHeader />
            <FormContainer>
                <Form onSubmitClick={handleSubmit} 
                    initialValues={nonAuthPerDtls}
                    key={JSON.stringify(nonAuthPerDtls)}
                    render={(formRenderProps)=>(
                        <FormElement>
                            <fieldset>
                            <Field component={FormTitle} id={appDetailsData.formContainerTitle.T1} name={appDetailsData.formContainerTitle.T2.name} />

                            <Field component={CusFormLabel} 
                                leftLabelId={'lblN'} leftLabelName={appDetailsData.label.n}
                                id={'n'} name={response.ApplicantsDtlsMyInfo.Name}/>
                            
                            <Field component={CusFormLabel} 
                                leftLabelId={'lblCC'} leftLabelName={appDetailsData.label.cc}
                                id={'cc'} name={'+65 Singapore'}/>
         
                            <Field component={CusFormInput} 
                                leftLabelId={'lblmno'} leftLabelName={appDetailsData.label.mno} 
                                id={'mno'} name={'mno'} placeholder={'Please input'} maxLength={8} 
                                disabled={false}  
                                validator={mobileNoValidator} />
         
                            <Field component={CusFormInput} 
                                leftLabelId={'lblem'} leftLabelName={appDetailsData.label.em} 
                                id={'em'} name={'em'} placeholder={'Please input'} 
                                disabled={false} 
                                maxLength={60} validator={emailValidator} /> 

                            <FieldWrapper>
                                <div className="row around-xs inputPair elementVisible">
                                    <div className="col-xs-12 col-sm-12 col-md-12 col-lg-12"  style={{ paddingBottom: "20px" }}>
                                        <button type={"button"} className="btn btn-back" onClick={backBtnClick}>{config.btnName.Back}</button>
                                        <button type={'submit'} className="k-button btn btn-success btn-float-right"  disabled={!formRenderProps.valid}>{config.btnName.Next}</button>
                                    </div>
                                </div> 
                            </FieldWrapper>
                            <CusToast className="popUpBox" trigger={isError} setTrigger={setIsError} label={errMsg} timer={timer} /> 
                            </fieldset>
                        </FormElement> )} >
                </Form>
            </FormContainer>
        </div>
    )
}

export default NonAuthPersonDetails